import React, {useMemo} from "react"
import {
  AdministrationLayout,
  ContentCard,
  BironTable,
} from "@biron-data/react-components";
import {useSelector} from "react-redux";
import {getDataModels} from "../../redux/environment.selector";
import Language from "../../language";
import {
  buildWorkspaceAdminDatamodelsUri,
  buildWorkspaceAdminDatamodelUri,
} from "../../commons/buildWorkspaceAdminUri";
import {getCurrentWorkspaceExpanded} from "../../redux/workspace.selector";
import AdminBreadcrumb from "components/admin/Admin.Breadcrumb";
import styled from "styled-components";
import EditableTitle from "../editableTitle/EditableTitle";
import {TableColumnProps} from "antd";
import {DatamodelDto} from "@biron-data/bqconf";

const DatamodelList = () => {
  const datamodels = useSelector(getDataModels)
  const workspace = useSelector(getCurrentWorkspaceExpanded)

  const columns: TableColumnProps<DatamodelDto>[] = useMemo(() => ([
    {
      title: Language.get("admin.datamodels.columns.name"),
      width: '16%',
      render: function render(_, datamodel) {
        return <EditableTitle
          fontSize={14}
          title={datamodel.alias}
          link={workspace ? buildWorkspaceAdminDatamodelUri(workspace, datamodel.code) : undefined} />
      },
    },
    {
      title: Language.get("admin.datamodels.columns.description"),
      width: '84%',
      render: (_, datamodel) => {
        return <DivWithCenteredContent>{datamodel.description}</DivWithCenteredContent>
      }
    }
  ]), [workspace])

  return <AdministrationLayout breadcrumb={<AdminBreadcrumb
    category={{
      link: workspace ? buildWorkspaceAdminDatamodelsUri(workspace) : undefined,
      title: Language.get("admin.datamodels.breadcrumb.title")
    }} />}>
    <ContentCard title={Language.get("admin.datamodels.content.title")} contentBgColor={'#F6F6F8'} actions={[]}>
      <BironTable dataSource={datamodels} columns={columns}/>
    </ContentCard>
  </AdministrationLayout>
}

export default DatamodelList


const DivWithCenteredContent = styled.div`
  display: flex;
  align-items: center;
`